export const permissionLevelEnum = {
    ADMIN: 0,
    SUPERVISION: 1,
    PLANNING: 2,
    CONDUC: 3,
    OBSERVERS: 15,
    TERRAIN: 30,
    CHAUFFEUR: 35,
};
